import { useNullableContext } from '~/common/contexts/nullableContext';
import { DealConfigsContext } from '../../DealConfigsContext';
import { DealConfigsContextType } from '../../types/DealConfigsContextType';

export const useDealConfigs = (): DealConfigsContextType => {
  const dealConfigs = useNullableContext(
    DealConfigsContext,
    'useDealConfigs must be used within a DealConfigsContext.Provider',
  );

  return dealConfigs;
};
